export const namespace = 'enums';

export const MutationTypes = {
  SET_ENUMS: 'SET_ENUMS',
};

export const ActionTypes = {
  GET_ENUMS: 'GET_ENUMS',
};
